import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export type AnimationEffect = 'scroll' | 'fade' | 'typewriter' | 'slide-up' | 'none';

interface AnnouncementBar {
  id: string;
  text: string;
  background_color: string;
  text_color: string;
  is_enabled: boolean;
  scroll_speed: number;
  animation_effect: AnimationEffect;
}

export const useAnnouncementBar = () => {
  const [announcement, setAnnouncement] = useState<AnnouncementBar | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchAnnouncement = async () => {
    const { data } = await supabase
      .from('announcement_bar')
      .select('*')
      .limit(1)
      .maybeSingle();
    
    setAnnouncement(data as AnnouncementBar | null);
    setLoading(false);
  };

  useEffect(() => {
    fetchAnnouncement();
  }, []);

  const updateAnnouncement = async (updates: Partial<AnnouncementBar>) => {
    if (!announcement) return;
    const { error } = await supabase
      .from('announcement_bar')
      .update(updates)
      .eq('id', announcement.id);
    
    if (!error) {
      setAnnouncement(prev => prev ? { ...prev, ...updates } : prev);
    }
    return { error };
  };

  return { announcement, loading, updateAnnouncement, refetch: fetchAnnouncement };
};
